<script>
  import options from './FormInputRichText.options'
  export default options
</script>

<template>
	
	<div class="Form__Element FormTextbox FormTextbox--RichText" :class="{ ValidationRequired: isRequired, ValidationError: isValidationError }">
		<label
			:for="fieldName"
			class="Form__Element__Caption"
			>{{ label }}
		</label>
		
		<editor
			v-if="editorReady"
			:model-value="localValue"
			@update:modelValue="onEditorUpdate"
			required
			aria-required="true"
			aria-describedby="fundraiseReason_desc"
			aria-invalid="false"
			:init="editorInit"
            />
	
		<p
			class="kb-forms Form__Element__ValidationError"
			v-if="isValidationError"
			>{{ errorMessageLabel }}
		</p>
	</div>

</template>
